import { Injectable } from '@angular/core';
import { TopicLevel2Query, TopicLevel2UIModel } from '@examdojo/category/v2';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { Observable } from 'rxjs';

@Injectable()
export class TopicListViewService extends AbstractSimpleListViewService<TopicLevel2UIModel> {
  constructor(private readonly topicLevel2Query: TopicLevel2Query) {
    super();
  }

  readonly data$: Observable<TopicLevel2UIModel[]> = this.topicLevel2Query.entities$;
  readonly loading$: Observable<boolean> = this.topicLevel2Query.selectLoading();
}
